export interface State {
    name: string;
    code: string;
}

export interface Lea {
  county: string;
  leaId: string;
  leaName: string;
}

const NEW_HANOVER = 'New Hanover';

export const counties: string[] = [
  'Alamance',
  'Alexander',
  'Alleghany',
  'Anson',
  'Ashe',
  'Avery',
  'Beaufort',
  'Bertie',
  'Bladen',
  'Brunswick',
  'Buncombe',
  'Burke',
  'Cabarrus',
  'Caldwell',
  'Camden',
  'Carteret',
  'Caswell',
  'Catawba',
  'Chatham',
  'Cherokee',
  'Chowan',
  'Clay',
  'Cleveland',
  'Columbus',
  'Craven',
  'Cumberland',
  'Currituck',
  'Dare',
  'Davidson',
  'Davie',
  'Duplin',
  'Durham',
  'Edgecombe',
  'Forsyth',
  'Franklin',
  'Gaston',
  'Gates',
  'Graham',
  'Granville',
  'Greene',
  'Guilford',
  'Halifax',
  'Harnett',
  'Haywood',
  'Henderson',
  'Hertford',
  'Hoke',
  'Hyde',
  'Iredell',
  'Jackson',
  'Johnston',
  'Jones',
  'Lee',
  'Lenoir',
  'Lincoln',
  'Macon',
  'Madison',
  'Martin',
  'McDowell',
  'Mecklenburg',
  'Mitchell',
  'Montgomery',
  'Moore',
  'Nash',
  'New Hanover',
  'Northampton',
  'Onslow',
  'Orange',
  'Pamlico',
  'Pasquotank',
  'Pender',
  'Perquimans',
  'Person',
  'Pitt',
  'Polk',
  'Randolph',
  'Richmond',
  'Robeson',
  'Rockingham',
  'Rowan',
  'Rutherford',
  'Sampson',
  'Scotland',
  'Stanly',
  'Stokes',
  'Surry',
  'Swain',
  'Transylvania',
  'Tyrrell',
  'Union',
  'Vance',
  'Wake',
  'Warren',
  'Washington',
  'Watauga',
  'Wayne',
  'Wilkes',
  'Wilson',
  'Yadkin',
  'Yancey'
];

export const gradeLevels: string[] = [
  'Kindergarten',
  'First Grade',
  'Second Grade',
  'Third Grade',
  'Fourth Grade',
  'Fifth Grade',
  'Sixth Grade',
  'Seventh Grade',
  'Eighth Grade',
  'Ninth Grade',
  'Tenth Grade',
  'Eleventh Grade',
  'Twelfth Grade '
];

export const lea: Lea[] = [
  { county: 'Alamance', leaId: '010', leaName: 'Alamance-Burlington Schools' },
  { county: 'Alexander', leaId: '020', leaName: 'Alexander County Schools' },
  { county: 'Alleghany', leaId: '030', leaName: 'Alleghany County Schools' },
  { county: 'Anson', leaId: '040', leaName: 'Anson County Schools' },
  { county: 'Ashe', leaId: '050', leaName: 'Ashe County Schools' },
  { county: 'Avery', leaId: '060', leaName: 'Avery County Schools' },
  { county: 'Beaufort', leaId: '070', leaName: 'Beaufort County Schools' },
  { county: 'Bertie', leaId: '080', leaName: 'Bertie County Schools' },
  { county: 'Bladen', leaId: '090', leaName: 'Bladen County Schools' },
  { county: 'Brunswick', leaId: '100', leaName: 'Brunswick County Schools' },
  { county: 'Buncombe', leaId: '110', leaName: 'Buncombe County Schools' },
  { county: 'Buncombe', leaId: '111', leaName: 'Asheville City Schools' },
  { county: 'Burke', leaId: '120', leaName: 'Burke County Schools' },
  { county: 'Cabarrus', leaId: '130', leaName: 'Cabarrus County Schools' },
  { county: 'Cabarrus', leaId: '132', leaName: 'Kannapolis City Schools' },
  { county: 'Caldwell', leaId: '140', leaName: 'Caldwell County Schools' },
  { county: 'Camden', leaId: '150', leaName: 'Camden County Schools' },
  { county: 'Carteret', leaId: '160', leaName: 'Carteret County Public Schools' },
  { county: 'Caswell', leaId: '170', leaName: 'Caswell County Schools' },
  { county: 'Catawba', leaId: '180', leaName: 'Catawba County Schools' },
  { county: 'Catawba', leaId: '181', leaName: 'Hickory City Schools' },
  { county: 'Catawba', leaId: '182', leaName: 'Newton Conover City Schools' },
  { county: 'Chatham', leaId: '190', leaName: 'Chatham County Schools' },
  { county: 'Cherokee', leaId: '200', leaName: 'Cherokee County Schools' },
  { county: 'Chowan', leaId: '210', leaName: 'Edenton-Chowan Schools' },
  { county: 'Clay', leaId: '220', leaName: 'Clay County Schools' },
  { county: 'Cleveland', leaId: '230', leaName: 'Cleveland County Schools' },
  { county: 'Columbus', leaId: '240', leaName: 'Columbus County Schools' },
  { county: 'Columbus', leaId: '241', leaName: 'Whiteville City Schools' },
  { county: 'Craven', leaId: '250', leaName: 'Craven County Board of Education' },
  { county: 'Cumberland', leaId: '260', leaName: 'Cumberland County Schools' },
  { county: 'Currituck', leaId: '270', leaName: 'Currituck County Schools' },
  { county: 'Dare', leaId: '280', leaName: 'Dare County Schools' },
  { county: 'Davidson', leaId: '290', leaName: 'Davidson County Schools' },
  { county: 'Davidson', leaId: '291', leaName: 'Lexington City Schools' },
  { county: 'Davidson', leaId: '292', leaName: 'Thomasville City Schools' },
  { county: 'Robeson', leaId: '295', leaName: 'Innovative School District' },
  { county: 'Davie', leaId: '300', leaName: 'Davie County Schools' },
  { county: 'Duplin', leaId: '310', leaName: 'Duplin County Schools' },
  { county: 'Durham', leaId: '320', leaName: 'Durham Public Schools' },
  { county: 'Edgecombe', leaId: '330', leaName: 'Edgecombe County Public Schools' },
  { county: 'Forsyth', leaId: '340', leaName: 'Winston Salem / Forsyth County Schools' },
  { county: 'Forsyth', leaId: '34Z', leaName: 'Appalachian State U Academy Middle Fork' },
  { county: 'Franklin', leaId: '350', leaName: 'Franklin County Schools' },
  { county: 'Gaston', leaId: '360', leaName: 'Gaston County Schools' },
  { county: 'Gates', leaId: '370', leaName: 'Gates County Schools' },
  { county: 'Graham', leaId: '380', leaName: 'Graham County Schools' },
  { county: 'Granville', leaId: '390', leaName: 'Granville County Schools' },
  { county: 'Greene', leaId: '400', leaName: 'Greene County Schools' },
  { county: 'Guilford', leaId: '410', leaName: 'Guilford County Schools' },
  { county: 'Guilford', leaId: '41Z', leaName: 'Aggie Academy' },
  { county: 'Halifax', leaId: '420', leaName: 'Halifax County Schools' },
  { county: 'Halifax', leaId: '421', leaName: 'Roanoke Rapids City Schools' },
  { county: 'Halifax', leaId: '422', leaName: 'Weldon City Schools' },
  { county: 'Harnett', leaId: '430', leaName: 'Harnett County Schools' },
  { county: 'Haywood', leaId: '440', leaName: 'Haywood County Schools' },
  { county: 'Henderson', leaId: '450', leaName: 'Henderson County Schools' },
  { county: 'Hertford', leaId: '460', leaName: 'Hertford County Schools' },
  { county: 'Hoke', leaId: '470', leaName: 'Hoke County Schools' },
  { county: 'Hyde', leaId: '480', leaName: 'Hyde County Schools' },
  { county: 'Iredell', leaId: '490', leaName: 'Iredell-Statesville Schools' },
  { county: 'Iredell', leaId: '491', leaName: 'Mooresville Graded School District' },
  { county: 'Jackson', leaId: '500', leaName: 'Jackson County Public Schools' },
  { county: 'Jackson', leaId: '50Z', leaName: 'Catamount School' },
  { county: 'Johnston', leaId: '510', leaName: 'Johnston County Public Schools' },
  { county: 'Jones', leaId: '520', leaName: 'Jones County Schools' },
  { county: 'Lee', leaId: '530', leaName: 'Lee County Schools' },
  { county: 'Lenoir', leaId: '540', leaName: 'Lenoir County Public Schools' },
  { county: 'Lincoln', leaId: '550', leaName: 'Lincoln County Schools' },
  { county: 'Macon', leaId: '560', leaName: 'Macon County Schools' },
  { county: 'Madison', leaId: '570', leaName: 'Madison County Schools' },
  { county: 'Martin', leaId: '580', leaName: 'Martin County Schools' },
  { county: 'McDowell', leaId: '590', leaName: 'McDowell County Schools' },
  { county: 'Mecklenburg', leaId: '600', leaName: 'Charlotte-Mecklenburg Schools' },
  { county: 'Mecklenburg', leaId: '60Z', leaName: 'Niner University Elementary School' },
  { county: 'Mitchell', leaId: '610', leaName: 'Mitchell County Schools' },
  { county: 'Montgomery', leaId: '620', leaName: 'Montgomery County Schools' },
  { county: 'Moore', leaId: '630', leaName: 'Moore County Schools' },
  { county: 'Nash', leaId: '640', leaName: 'Nash County Public Schools' },
  { county: NEW_HANOVER, leaId: '650', leaName: 'New Hanover County Schools' },
  { county: NEW_HANOVER, leaId: '65Z', leaName: 'D.C. Virgo Preparatory Academy' },
  { county: 'Northampton', leaId: '660', leaName: 'Northampton County Schools' },
  { county: 'Onslow', leaId: '670', leaName: 'Onslow County Schools' },
  { county: 'Orange', leaId: '680', leaName: 'Orange County Schools' },
  { county: 'Orange', leaId: '681', leaName: 'Chapel Hill-Carrboro City Schools' },
  { county: 'Pamlico', leaId: '690', leaName: 'Pamlico County Schools' },
  { county: 'Pasquotank', leaId: '700', leaName: 'Elizabeth City-Pasquotank Public Schools' },
  { county: 'Pender', leaId: '710', leaName: 'Pender County Schools' },
  { county: 'Perquimans', leaId: '720', leaName: 'Perquimans County Schools' },
  { county: 'Person', leaId: '730', leaName: 'Person County Schools' },
  { county: 'Person', leaId: '73Z', leaName: 'Carolina Community Academy' },
  { county: 'Pitt', leaId: '740', leaName: 'Pitt County Schools' },
  { county: 'Pitt', leaId: '74Z', leaName: 'East Carolina Community School' },
  { county: 'Polk', leaId: '750', leaName: 'Polk County Schools' },
  { county: 'Randolph', leaId: '760', leaName: 'Randolph County School System' },
  { county: 'Randolph', leaId: '761', leaName: 'Asheboro City Schools' },
  { county: 'Richmond', leaId: '770', leaName: 'Richmond County Schools' },
  { county: 'Robeson', leaId: '780', leaName: 'Public Schools of Robeson County' },
  { county: 'Rockingham', leaId: '790', leaName: 'Rockingham County Schools' },
  { county: 'Rowan', leaId: '800', leaName: 'Rowan-Salisbury Schools' },
  { county: 'Rutherford', leaId: '810', leaName: 'Rutherford County Schools' },
  { county: 'Sampson', leaId: '820', leaName: 'Sampson County Schools' },
  { county: 'Sampson', leaId: '821', leaName: 'Clinton City Schools' },
  { county: 'Scotland', leaId: '830', leaName: 'Scotland County Schools' },
  { county: 'Stanly', leaId: '840', leaName: 'Stanly County Schools' },
  { county: 'Stokes', leaId: '850', leaName: 'Stokes County Schools' },
  { county: 'Surry', leaId: '860', leaName: 'Surry County Schools' },
  { county: 'Surry', leaId: '861', leaName: 'Elkin City Schools' },
  { county: 'Surry', leaId: '862', leaName: 'Mount Airy City Schools' },
  { county: 'Surry', leaId: '86Z', leaName: 'Appalachian State Univ Academy at Elkin' },
  { county: 'Swain', leaId: '870', leaName: 'Swain County Schools' },
  { county: 'Transylvania', leaId: '880', leaName: 'Transylvania County Schools' },
  { county: 'Tyrrell', leaId: '890', leaName: 'Tyrrell County Schools' },
  { county: 'Union', leaId: '900', leaName: 'Union County Public Schools' },
  { county: 'Vance', leaId: '910', leaName: 'Vance County Schools' },
  { county: 'Wake', leaId: '920', leaName: 'Wake County Schools' },
  { county: 'Warren', leaId: '930', leaName: 'Warren County Schools' },
  { county: 'Washington', leaId: '940', leaName: 'Washington County Schools' },
  { county: 'Watauga', leaId: '950', leaName: 'Watauga County Schools' },
  { county: 'Wayne', leaId: '960', leaName: 'Wayne County Public Schools' },
  { county: 'Wilkes', leaId: '970', leaName: 'Wilkes County Schools' },
  { county: 'Wilson', leaId: '980', leaName: 'Wilson County Schools' },
  { county: 'Yadkin', leaId: '990', leaName: 'Yadkin County Schools' },
  { county: 'Yancey', leaId: '995', leaName: 'Yancey County Schools' }
];

export const states: State[] = [
    { name: 'North Carolina', code: 'NC' },
    { name: 'Alabama', code: 'AL' },
    { name: 'Alaska', code: 'AK' },
    { name: 'Arizona', code: 'AZ' },
    { name: 'Arkansas', code: 'AR' },
    { name: 'California', code: 'CA' },
    { name: 'Colorado', code: 'CO' },
    { name: 'Connecticut', code: 'CT' },
    { name: 'Delaware', code: 'DE' },
    { name: 'Florida', code: 'FL' },
    { name: 'Georgia', code: 'GA' },
    { name: 'Hawaii', code: 'HI' },
    { name: 'Idaho', code: 'ID' },
    { name: 'Illinois', code: 'IL' },
    { name: 'Indiana', code: 'IN' },
    { name: 'Iowa', code: 'IA' },
    { name: 'Kansas', code: 'KS' },
    { name: 'Kentucky', code: 'KY' },
    { name: 'Louisiana', code: 'LA' },
    { name: 'Maine', code: 'ME' },
    { name: 'Maryland', code: 'MD' },
    { name: 'Massachusetts', code: 'MA' },
    { name: 'Michigan', code: 'MI' },
    { name: 'Minnesota', code: 'MN' },
    { name: 'Mississippi', code: 'MS' },
    { name: 'Missouri', code: 'MO' },
    { name: 'Montana', code: 'MT' },
    { name: 'Nebraska', code: 'NE' },
    { name: 'Nevada', code: 'NV' },
    { name: 'New Hampshire', code: 'NH' },
    { name: 'New Jersey', code: 'NJ' },
    { name: 'New Mexico', code: 'NM' },
    { name: 'New York', code: 'NY' },
    { name: 'North Dakota', code: 'ND' },
    { name: 'Ohio', code: 'OH' },
    { name: 'Oklahoma', code: 'OK' },
    { name: 'Oregon', code: 'OR' },
    { name: 'Pennsylvania', code: 'PA' },
    { name: 'Rhode Island', code: 'RI' },
    { name: 'South Carolina', code: 'SC' },
    { name: 'South Dakota', code: 'SD' },
    { name: 'Tennessee', code: 'TN' },
    { name: 'Texas', code: 'TX' },
    { name: 'Utah', code: 'UT' },
    { name: 'Vermont', code: 'VT' },
    { name: 'Virginia', code: 'VA' },
    { name: 'Washington', code: 'WA' },
    { name: 'West Virginia', code: 'WV' },
    { name: 'Wisconsin', code: 'WI' },
    { name: 'Wyoming', code: 'WY' },
];
